import { ISportsState } from '@/store/modules/sports/types'

export const sportsState: ISportsState = {
  sports: [],
}
